import React from 'react';
import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css'; // 复用登录页面的样式

const Register = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      if (values.password !== values.confirmPassword) {
        form.setFields([{
          name: 'confirmPassword',
          errors: ['两次输入的密码不一致']
        }]);
        return;
      }

      const success = await register(values.username, values.password);
      if (success) {
        navigate('/login');
      }
    } catch (error) {
      console.error('注册失败:', error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1 className="login-title">注册账号</h1>
        <Form
          form={form}
          name="register"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入用户名' },
              { min: 3, message: '用户名至少3个字符' }
            ]}
          >
            <Input
              prefix={<UserOutlined className="input-icon" />}
              placeholder="用户名"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6个字符' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="input-icon" />}
              placeholder="密码"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            rules={[
              { required: true, message: '请确认密码' },
              { min: 6, message: '密码至少6个字符' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="input-icon" />}
              placeholder="确认密码"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large" className="login-button">
              注册
            </Button>
          </Form.Item>

          <div className="login-links">
            <span>已有账号？</span>
            <Link to="/login" className="register-link">立即登录</Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Register; 